exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-active-tabs[data-v-2cfc68e1]{display:flex;justify-content:space-around;padding:10px 0;background-color:#f1f1f1;border-bottom:#ff5b60;position:fixed;top:50px;width:100%;border-bottom:1px solid #bdbdbd}.price-active-tabs__tab[data-v-2cfc68e1]{cursor:pointer;padding:5px}.price-active-tabs__tab.is-active[data-v-2cfc68e1]{color:#ff5b60;border:1px solid #ff5b60;border-radius:10px}@media screen and (max-width:650px){.text-wrap[data-v-2cfc68e1]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cfc68e1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/priceList/parts/PriceCategoryTabs.vue
// module id = 484
// module chunks = 0